import { useDispatch } from "react-redux";

import { useChatWorkflowShared } from "@intelligems/ig-plugin/builder";
import { UiStreamAction } from "@intelligems/ig-types";
import { aiApiClient } from "@src/api/ai-api";
import { handleAiChatAction } from "@src/store/slices/aiChat";

export const useUiActionWorkflow = (
  setRestartFromFirstNode?: (value: boolean) => void
) => {
  const dispatch = useDispatch();

  const cb = (data: UiStreamAction) => {
    if (
      setRestartFromFirstNode &&
      data.type === "addStreamPart" &&
      data.streamPart.type === "tool-input-available" &&
      data.streamPart.toolName === "request-user-input"
    ) {
      setRestartFromFirstNode(false);
    }

    dispatch(handleAiChatAction(data));
  };

  const chatWorkflow = useChatWorkflowShared(aiApiClient, cb);

  return { chatWorkflow };
};
